import Section from './component';

export default Section;
